export default __webpack_public_path__ + "static/media/Background.70fff25b.png";